import React, { useEffect, useState } from "react"; 
import "./App.css";
import axios from "./axios";
import { ProgressBar } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {

const [result, setResult] = useState("");

function getInfo() {
  axios.get("https://evening-ridge-26996.herokuapp.com/api/hello").then((response) => {
    // console.log("changed" + response.data)
    setResult(response.data);
  });
}

useEffect(() => {
  getInfo()
  const interval = setInterval(() => {
    // console.log('This runs every 4 seconds');
    getInfo()
  }, 4000);
  return () => clearInterval(interval); 
}, []);

const total = result/2000000;
const percent = total * 100;
return (
  <main>
    <div className="container">
      <ProgressBar now={percent} label={`${result.toLocaleString()} Signatures`} />
    </div>
    </main>
);


}

export default App;